import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
//样式文件
import '@/assets/css/common.css'


const router = new Router({
    routes: [
        {path: '/', redirect: '/login'},
        {path: '/login', name: 'login', component: () => import('@/page/login/login')},//登录
        // 大厅模块
        {path: '/deskNum', name: 'deskNum', component: () => import('@/page/hall/deskNum')}, // 开台
        {path: '/addFood', name: 'addFood', component: () => import('@/page/hall/addFood')}, // 添加菜品
        {path: '/goEditFood', name: 'goEditFood', component: () => import('@/page/hall/goEditFood')}, // 编辑菜品
        {path: '/worker', name: 'worker', component: () => import('@/page/hall/worker/worker')}, // 人员管理
        {path: '/addWorker', name: 'addWorker', component: () => import('@/page/hall/worker/addWorker')}, // 添加员工
        {path: '/editWorker', name: 'editWorker', component: () => import('@/page/hall/worker/editWorker')}, // 编辑员工
        {path: '/addDesk', name: 'addDesk', component: () => import('@/page/hall/desk/addDesk')}, // 添加桌位
        {path: '/editDesk', name: 'editDesk', component: () => import('@/page/hall/desk/editDesk')}, // 编辑桌位
        // 中转页
        {path: '/middlePage', name: 'middlePage', component: () => import('@/page/common/middlePage')}, // 中转页
        {path: '/addDish', name: 'addDish', component: () => import('@/page/hall/addDish')}, // 加菜
        {path: '/orderDish', name: 'orderDish', component: () => import('@/page/hall/orderDish')}, // 点餐
        {path: '/payWay', name: 'payWay', component: () => import('@/page/hall/payWay')}, // 支付
        {path: '/paySuccess', name: 'paySuccess', component: () => import('@/page/hall/paySuccess')}, // 支付成功
        {path: '/revenue', name: 'revenue', component: () => import('@/page/hall/dataTable/revenue')}, // 营收
        // -----------------------大厅-设置 开始---------------------
        {path: '/settingNew', name: 'settingNew', component: () => import('@/page/common/setting/settingNew')},//设置-新
        {path: '/storeInfo', name: 'storeInfo', component: () => import('@/page/common/setting/storeInfo')},//设置-门店信息
        {path: '/storePaw', name: 'storePaw', component: () => import('@/page/common/setting/storePaw')},//设置-店长密码
        {path: '/storeModel', name: 'storeModel', component: () => import('@/page/common/setting/storeModel')},//设置-店长模式
        {path: '/contact', name: 'contact', component: () => import('@/page/common/setting/contact')},//设置-联系客服
        {path: '/aboutDZB', name: 'aboutDZB', component: () => import('@/page/common/setting/aboutDZB')},//设置-关于店掌宝
        {path: '/agreementPolicy', name: 'agreementPolicy', component: () => import('@/page/common/setting/agreementPolicy')},//设置-协议政策/隐私政策
        {path: '/setPrintType', name: 'setPrintType', component: () => import('@/page/common/setting/setPrintType')}, // 设置-打印设置
        {path: '/deskCode', name: 'deskCode', component: () => import('@/page/common/setting/deskCode')},//设置-桌位管理
        {path: '/memberCategory', name: 'memberCategory', component: () => import('@/page/common/setting/memberCategory')},//设置-会员类型
        // -----------------------大厅-设置 结束---------------------
        // 大厅-改 开始
        {path: '/orderList', name: 'orderList', component: () => import('@/page/hall/orderList')}, // 订单列表
        // 大厅-改 结束
        // 会员模块
        {path: '/member', name: 'member', component: () => import('@/page/hall/member')}, //会员
        {path: '/addmember', name: 'addmember', component: () => import('@/page/hall/addmember')}, //新增会员
        {path: '/memberrecord', name: 'memberrecord', component: () => import('@/page/hall/memberrecord')}, //会员消费记录
        // 打印机设置
        {path: '/addQiantaiPrint', name: 'addQiantaiPrint', component: () => import('@/page/common/setting/addQiantaiPrint')}, // 添加前台打印机
        {path: '/addHouchuPrint', name: 'addHouchuPrint', component: () => import('@/page/common/setting/addHouchuPrint')}, // 添加后厨打印机
        {path: '/smsSet', name: 'smsSet', component: () => import('@/page/common/setting/smsSet')}, // 短信提醒设置
        {path: '/smsRecord', name: 'smsRecord', component: () => import('@/page/common/setting/smsRecord')}, // 短信消费记录
        // 快餐
        {path: '/fastfood', name: 'fastfood', component: () => import('@/page/hall/fastfood')}, // 快餐

        {path: '/foodManage', name: 'foodManage', component: () => import('@/page/common/setting/foodManage')}, // 菜单管理
        {path: '/storeSetting', name: 'storeSetting', component: () => import('@/page/common/setting/storeSetting')}, // 门店设置
        {
            path: '/storeRole',
            name: 'storeRole',
            component: () => import('@/page/common/setting/storeRole.vue'),
            meta: { title: '权限管理' }
        },
        {path: '/specificationManage', name: 'specificationManage', component: () => import('@/page/common/setting/specificationManage')}, // 规格设置
        {path: '/specificationSetting', name: 'specificationSetting', component: () => import('@/page/common/setting/specificationSetting')}, // 菜品规格进行设置

        // 单独的页面，菜品图片上传
        {path: '/uplodaFoodImage', name: 'uplodaFoodImage', component: () => import('@/page/scan-upload/uploda-image')}, // 菜品图片上传
        {path: '/uplodaFoodImageSuccess', name: 'uplodaFoodImageSuccess', component: () => import('@/page/scan-upload/uploda-success')}, // 菜品图片上传成功

        {path: '/addLabelPrint', name: 'addLabelPrint', component: () => import('@/page/common/setting/addLabelPrint')}, // 添加标签打印机

        {path: '/setMealSetting', name: 'setMealSetting', component: () => import('@/page/common/setting/setMealSetting')}, // 套餐菜品设置

        {path: '/stockManage', name: 'stockManage', component: () => import('@/page/common/setting/stockManage')}, // 库存管理

        {path: '/sms-checklog', name: 'sms-checklog', component: () => import('@/page/common/setting/sms-checklog')}, // 手机号验证记录

        {path: '/check', name: 'check', component: () => import('@/page/hall/check')}, // 寄存
        {path: '/check-add', name: 'check-add', component: () => import('@/page/hall/check-add')}, // 新增寄存
        {path: '/check-datatable', name: 'check-datatable', component: () => import('@/page/hall/check-datatable')}, // 寄存统计
    ]
})

//路由守卫
router.beforeEach(async (to, from, next) => {
    if (to.path == '/login') {
        if (localStorage.getItem('token')) {
            next({name: 'middlePage'})
        } else {
            next()
        }
    } else {
        next()
    }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js